import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionSummary, Box, Divider, Icon, Typography } from '@mui/material'

export default function AdxAccordion({ icon, title, children, ...rest }) {
  return (
    <Accordion
      disableGutters
      sx={{
        width: '100%',
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, alignItems: 'center' }}>
          {icon && (
            <Box
              sx={{
                bgcolor: 'alternate.light',
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Icon sx={{ color: 'alternate.main' }}>{icon}</Icon>
            </Box>
          )}
          <Typography variant="h4">{title}</Typography>
        </Box>
      </AccordionSummary>
      <Divider />
      <Box
        sx={{
          px: 2,
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {children}
      </Box>
    </Accordion>
  )
}
